import api from './client';

export interface Workplace {
  id: number;
  name: string;
  department_id: number | null;
  description: string | null;
  department?: { id: number; name: string };
}

export const getWorkplaces = (department_id?: number) =>
  api.get<Workplace[]>('/workplaces', {
    params: department_id ? { department_id } : {},
  }).then(r => r.data);

export const createWorkplace = (data: Omit<Workplace, 'id' | 'department'>) =>
  api.post<Workplace>('/workplaces', data).then(r => r.data);

export const updateWorkplace = (id: number, data: Partial<Omit<Workplace, 'id' | 'department'>>) =>
  api.put<Workplace>(`/workplaces/${id}`, data).then(r => r.data);

export const deleteWorkplace = (id: number) =>
  api.delete(`/workplaces/${id}`);
